export const getParamsObject = paramsString => Object.fromEntries(new URLSearchParams(paramsString));
